import moment from "moment";

// Cálculos del Estado de cuenta, aparte del componente para poder probarlos.

// Días de mora de una cuota. La pagada conserva los que guardó el sistema al pagarla; la
// pendiente cuenta los días completos desde su fecha de pago (la de hoy todavía no está en mora).
export const diasMoraCuota = (cuota, hoy = moment()) => {
  if (cuota.isCanceled) return cuota.diasMora;
  const dias = moment(hoy).startOf("day").diff(moment(cuota.fechaPago).startOf("day"), "days");
  return dias > 0 ? dias : 0;
};

// Monto de la cuota como en el plan de pagos del crédito: en los nominales se paga el interés.
export const montoCuota = (cuota, isNominal) =>
  isNominal ? cuota.montoInteresCorriente : cuota.cuotaPrincipal;

// El servidor no garantiza el orden: el plan va por número de cuota y los abonos por fecha.
export const ordenarCuotas = (cuotas = []) =>
  [...cuotas].sort((a, b) => a.numeroCuota - b.numeroCuota);

export const ordenarAbonos = (abonos = []) =>
  [...abonos].sort(
    (a, b) => moment(a.fechaPago).valueOf() - moment(b.fechaPago).valueOf() || a.id - b.id
  );

// Los abonos anulados ya no llegan del servidor.
export const totalAbonado = (abonos = []) =>
  abonos.reduce((suma, abono) => suma + abono.totalRecibido, 0);

// Saldo del crédito: la suma del saldo de capital e interés corriente de las cuotas, la misma
// fórmula del sistema y del resumen del crédito (decisión del usuario 2026-10-06; antes el
// estado de cuenta mostraba monto a pagar − abonos).
export const saldoDelPlan = (cuotas = []) =>
  cuotas.reduce((suma, c) => suma + c.saldoPrincipal + c.saldoInteresCorriente, 0);
